import { Component, inject } from '@angular/core';
import { AbstractSelectionService } from 'gung-list';
import { EdiOrderListConfigService } from '../../../services/edi-order-list-config/edi-order-list-config.service';
import { ProductSelectionService } from '../../../services/product-selection-service/product-selection.service';

@Component({
    selector: 'lib-edi-list-orders',
    template: `<lib-edi-list-wrapper
      [configService]="configService"
      title="EDI - Orders">
    </lib-edi-list-wrapper>`,
    styleUrls: ['./edi-list-orders.component.css'],
    providers: [
        {
            provide: AbstractSelectionService,
            useClass: ProductSelectionService
        }
    ],
    standalone: false
})
export class EdiListOrdersComponent {
  public configService = inject(EdiOrderListConfigService);
}
